export const BASE_URL = 'https://apin.giftpedia.com.mx';
export const LOCAL_BASE_URL = 'https://apin.giftpedia.com.mx';
export const API_VERSION = 'api';
export const CONTAINER_FOLDER = '/containers/cloudgiftmaster';